import { Component, OnInit } from '@angular/core';

import { SeedService } from './seed.service';


export class SeedComponent implements OnInit {

	greeting: string;

	constructor(private service: SeedService) { }

	ngOnInit() {
		this.greeting = this.service.sayHello();
	}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
	selector: 'seed-component',
	template: '{{greeting}}'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SeedService, },
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
